import { render, staticRenderFns } from "./NAsyncSingleImageUploader.vue?vue&type=template&id=ef1f870c&scoped=true&"
import script from "./NAsyncSingleImageUploader.vue?vue&type=script&lang=js&"
export * from "./NAsyncSingleImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./NAsyncSingleImageUploader.vue?vue&type=style&index=0&id=ef1f870c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1f870c",
  null
  
)

export default component.exports